import * as React from "react";
import Box from "@mui/joy/Box";
import Divider from "@mui/joy/Divider";
import Stack from "@mui/joy/Stack";
import Chip from "@mui/joy/Chip";
import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import { Typography } from "@mui/joy";
import ReportSubmission from "../../Forms/ReportSubmission";
import CTFChallengeTable from "../../Tables/CTFChallenegeTable";

const formatDateTime = (dateTimeString: string) => {
  const date = new Date(dateTimeString);
  return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
};
const RenderEventContent = ({ data }: any) => {
  const stepsList = data.vpnconfiguration
    ? data.vpnconfiguration.split(",").filter(Boolean)
    : [];

  const rulesList = data.eventrules
    ? data.eventrules.split(",").filter(Boolean)
    : [];
  return (
    <Box sx={{ flex: 1, width: "100%" }}>
      <Stack
        spacing={1}
        direction="column"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "20px",
        }}
      >
        <Stack
          spacing={1}
          direction="row"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography level="title-lg">
              Organizer <br />
            </Typography>
            <Typography level="body-lg">{data.organizer}</Typography>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography level="title-lg">
              Category <br />
            </Typography>
            <Typography level="body-lg">{data.category}</Typography>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography level="title-lg">
              Start Date and Time
              <br />
            </Typography>
            <Typography level="body-lg">
              {formatDateTime(data.startdate)}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography level="title-lg">
              End Date and Time <br />
            </Typography>
            <Typography level="body-lg">
              {formatDateTime(data.enddate)}
            </Typography>
          </div>
        </Stack>
        <br />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography level="title-lg">
            Description <br />
          </Typography>
          <Typography level="body-lg">{data.eventdescription}</Typography>
        </div>{" "}
        <br />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography level="title-lg">
            Prize <br />
          </Typography>
          <Typography level="body-lg">{data.prize}</Typography>
        </div>{" "}
        <br />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography level="title-lg">
            Event Rules <br />
          </Typography>
        </div>
        <div>
          <List marker="decimal">
            {rulesList.map((step: string, index: number) => (
              <ListItem key={index}>
                <Typography level="body-lg" textAlign="left">
                  {step.trim()}
                </Typography>
              </ListItem>
            ))}
          </List>
        </div>{" "}
      </Stack>
      <div className="pt-4"></div>
      {data.category === "CTF" && (
        <>
          <Divider>
            <Chip variant="soft" color="neutral" size="md">
              Challenges
            </Chip>
          </Divider>
          <div className="pt-4"></div>
          <Stack spacing={2}>
            <CTFChallengeTable
              challenges={data.ctfChallenges}
              eventname={data.eventname}
            />
          </Stack>
        </>
      )}
      <div className="pt-4"></div>
      {data.category === "Bug Bounty" && (
        <>
          <div className="pt-4"></div>
          <Divider>
            <Chip variant="soft" color="neutral" size="md">
              VPN Configuration Details
            </Chip>
          </Divider>
          <div className="pt-4"></div>
          <Typography level="body-md">
            Follow these simple steps to configure your VPN and gain access to
            our network for participating in the {data.eventname} event. This
            guide will help you set up your VPN and ensure you can securely
            connect and contribute.
          </Typography>
          <List marker="decimal">
            {stepsList.map((step: string, index: number) => (
              <ListItem key={index}>
                <Typography level="body-lg" textAlign="justify">
                  {step.trim()}
                </Typography>
              </ListItem>
            ))}
          </List>
        </>
      )}
    </Box>
  );
};

export default RenderEventContent;
